import LoseUser from './LoseUser';

export default LoseUser;
